export const getTeacherSectionsLabel = (sections, options) =>
  options?.filter((option) =>
    sections?.some((section) => section === option?.value)
  );

const getSectionId = (sec) =>
  typeof sec === "object" ? sec?.id || sec?.value : sec;

export const calculateTotalClasses = (userSections, sections) => {
  const classSet = new Set();
  userSections?.forEach((sec) => {
    const secId = getSectionId(sec);
    const sectionObj = sections?.find((section) => section?.id === secId);
    if (sectionObj) classSet.add(sectionObj?.classroom?.id);
  });

  return classSet?.size;
};

export const calculateTotalStudents = (userSections, sections) =>
  userSections?.reduce((acc, sec) => {
    const secId = getSectionId(sec);
    const sectionObj = sections?.find((section) => {
      return section?.id === secId;
    });
    return acc + (sectionObj?.data?.numberOfStudents || 0);
  }, 0);
